import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import WordlistRow from './WordlistRow';
import WordlistContext, { EnrichedWord } from './_contexts/WordlistContext';

type WordlistSearchResultsProps = {
  searchTerm: string;
  error?: string;
  results?: EnrichedWord[];
};

export default function WordlistSearchResults({ searchTerm, error, results }: WordlistSearchResultsProps) {
  const { t } = useTranslation();

  const {
    switched,
    favoriteIds: favorites,
    toggleFavoriteWord,
    selectedWord,
    setSelectedWord,
  } = useContext(WordlistContext);

  if (searchTerm.length) {
    if (error) {
      return <p className="wordlist__search-error">{t(error)}</p>;
    }

    return (
      <>
        <header className="wordlist__header wordlist__header--level-0 p-mt-3">
          {t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.SEARCH_RESULTS')}
          <span className="wordlist__badge wordlist__badge--inverted" role="status">
            {results?.length}
          </span>
        </header>
        <div className="wordlist__list">
          <table className="wordlist__table">
            <tbody>
              {results?.map(word => (
                <WordlistRow
                  key={`word-${word.id}`}
                  word={word}
                  isFavorite={favorites.includes(word.id)}
                  onFavorite={() => toggleFavoriteWord(word.id)}
                  switched={switched}
                  isActive={selectedWord?.id === word.id}
                  onClick={() => setSelectedWord(word)}
                />
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }

  return null;
}
